export type GlobalAudioSource = 'fonoteka' | 'project-file';

export type GlobalAudioTrack = {
  instanceId: string;
  src: string;
  title: string;
  source: GlobalAudioSource;
  packId?: string;
};

/**
 * Откуда включили трек: соседи («следующий», «предыдущий», после конца трека) берутся из этого списка, а не из всей Фонотеки.
 * tracks — функция, а не готовый список: плейлист живой (в блок добавили трек — он сразу в плейлисте).
 */
export type GlobalAudioPlaylist = {
  key: string;
  tracks: () => readonly GlobalAudioTrack[];
};

export type GlobalAudioState = {
  track: GlobalAudioTrack | null;
};

export type GlobalAudioAction =
  | { type: 'set-track'; track: GlobalAudioTrack }
  | { type: 'close' };

export function reduceGlobalAudio(
  _state: GlobalAudioState,
  action: GlobalAudioAction,
): GlobalAudioState {
  switch (action.type) {
    case 'set-track':
      return { track: action.track };
    case 'close':
      return { track: null };
    default: {
      const _exhaustive: never = action;
      return _exhaustive;
    }
  }
}

export function shouldToggleCurrent(
  current: GlobalAudioTrack | null,
  next: GlobalAudioTrack,
): boolean {
  return current?.instanceId === next.instanceId;
}
